var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"xflip",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16.46 58.27"}},[_c('g',{staticClass:"a"},[_c('polyline',{staticClass:"b",attrs:{"points":"15.7 57.88 0.95 29.14 15.7 0.39"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }